var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeModalSearchPlace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#009BE2",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.125 55.759L64.7917 62.4337C65.0894 62.7649 65.0747 63.2718 64.7583 63.5851L63.5917 64.7532C63.4352 64.9112 63.2222 65 63 65C62.7778 65 62.5648 64.9112 62.4083 64.7532L55.7417 58.0785C55.5573 57.8937 55.3899 57.6927 55.2417 57.4778L53.9917 55.8091C51.9234 57.4626 49.3551 58.3629 46.7083 58.3622C41.2543 58.3811 36.515 54.6143 35.2962 49.2918C34.0774 43.9693 36.7043 38.5116 41.6218 36.1499C46.5393 33.7881 52.4349 35.1525 55.8183 39.4354C59.2017 43.7183 59.1699 49.7766 55.7417 54.0236L57.4083 55.175C57.6686 55.3418 57.909 55.5377 58.125 55.759ZM38.375 46.6814C38.375 51.2894 42.106 55.0248 46.7083 55.0248C48.9185 55.0248 51.0381 54.1458 52.6009 52.5811C54.1637 51.0164 55.0417 48.8942 55.0417 46.6814C55.0417 42.0735 51.3107 38.3381 46.7083 38.3381C42.106 38.3381 38.375 42.0735 38.375 46.6814Z",
    fill: "#009BE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeModalSearchPlace);
export default __webpack_public_path__ + "static/media/welcome-modal-search-place.762e67c788b585ca8cdd50b7acaa5cbb.svg";
export { ForwardRef as ReactComponent };